const { roundNumber } = require('../utils')
const { calculateMonthlyCost } = require('./calculate-monthly-cost')
const { calculateRate } = require('./calculate-rate')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {number} amount
 * @param {number} duration
 * @param {array} interests
 * @param {number} baseInterest
 * @returns {*}
 */
function calculateValues ({ amount, duration, interests, baseInterest } = {}) {
  if (!amount || !duration || !interests || !baseInterest) return

  let startupFee = 0
  let monthlyFee = 0
  let interest = baseInterest

  for (let i = 0; i < interests.length; i++) {
    const o = interests[i]
    const next = (i + 1 < interests.length ? interests[i + 1] : null)

    if (amount >= o.amount && (!next || amount < next.amount)) {
      interest = o.interestRate
      startupFee = o.startupFee
      monthlyFee = o.monthlyFee
      break
    }
  }

  startupFee = startupFee || 0
  monthlyFee = monthlyFee || 0

  const loanData = calculateRate({
    amount,
    duration,
    interest: (interest / 100),
    startupFee,
    monthlyFee
  })

  const monthlyCost = calculateMonthlyCost({
    amount,
    duration,
    interest,
    monthlyFee
  })

  return {
    amount,
    interest: roundNumber(interest, 2),
    effectiveInterest: roundNumber(loanData.estimatedAvgInterest, 2),
    startupFee: roundNumber(startupFee),
    monthlyFee: roundNumber(monthlyFee),
    monthlyCost: roundNumber(monthlyCost),
    occasions: duration,
    duration: duration / 12,
    cost: roundNumber(loanData.totalCost - amount),
    totalCost: roundNumber(loanData.totalCost)
  }
}

module.exports = { calculateValues }
